var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74732 0.871065C5.43122 1.42831 4.24989 2.22559 3.23617 3.2406C2.22245 4.25561 1.42635 5.43846 0.869655 6.75624C0.292609 8.12232 -5.206e-07 9.57151 -4.55381e-07 11.0635L-1.2071e-07 18.7199C-5.40462e-08 20.245 1.23486 21.4814 2.758 21.4814L19.3404 21.4814C20.8636 21.4814 22.0984 20.245 22.0984 18.7199L22.0984 11.0635C22.0984 10.4724 22.0524 9.88792 21.9611 9.3127C21.7513 7.99203 20.3413 7.23438 19.122 7.78007L15.4006 9.44571C15.5899 9.95659 15.6886 10.5024 15.6886 11.0635L15.6886 13.9964C15.6886 14.5858 15.2115 15.0634 14.6229 15.0634L7.47548 15.0634C6.8869 15.0634 6.40985 14.5858 6.40985 13.9964L6.40984 11.0635C6.40984 9.82277 6.89235 8.6563 7.76873 7.77895C8.64496 6.90145 9.80995 6.41833 11.0493 6.41833C11.6161 6.41833 12.1673 6.51941 12.6825 6.71308L14.3706 3.00121C14.9256 1.78066 14.1723 0.363399 12.8505 0.14631C12.259 0.0492377 11.6576 0.000297037 11.0491 0.000297063C9.559 0.000297129 8.11166 0.293281 6.74732 0.871065Z",
    fill: "#F22E62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderlogo);
export default __webpack_public_path__ + "static/media/headerlogo.8de891c0a23554a35a7f51dc9ffc91bb.svg";
export { ForwardRef as ReactComponent };